import type { StatusVariants } from "@/components/molecules";
import type { PaginatedResponse } from "@/types/api";

export enum AuditActionType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

export interface AuditLogItem {
  id: string;
  timestamp: string;
  username: string;
  adminAccountId: string;
  action: AuditActionType;
  entityType: string;
  entityId?: string;
  parentEntityId?: string;
  brandId?: string;
  entityName: string;
  entityUpdatedAt?: string;
  isEntityDeleted?: boolean;
  canViewEntity?: boolean;
  before: {
    [key: string]: string;
  } | null;
  after: {
    [key: string]: string;
  } | null;
}

export const auditLogActionMap: Record<string, AuditActionType> = {
  Create: AuditActionType.CREATE,
  Update: AuditActionType.UPDATE,
  Delete: AuditActionType.DELETE,
};

export const AUDIT_LOG_ACTIONS_VARIANT_MAP: StatusVariants = {
  Create: { badge: "success", dot: "#65A30D" },
  Update: { badge: "info", dot: "#D97706" },
  Delete: { badge: "warning", dot: "#DC2626" },
};

export interface EntityHistoryItem {
  id: string;
  timestamp: string;
  username?: string;
  adminAccountId: string;
  action: AuditActionType;
  entityType: string;
  entityId: string;
  entityUpdatedAt: string;
  entityName: string;
  isEntityDeleted?: boolean;
  canViewEntity?: boolean;
  before: {
    [key: string]: string;
  };
  after: {
    [key: string]: string;
  };
  isSystem?: boolean;
}

export type EntityHistoryResponse = PaginatedResponse<EntityHistoryItem>;
